import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	authentication: false,
	name: "",
	email: "",
	isAdmin: false,
	isSuperAdmin: false,
	isViewer: false,
	isUser: false,
	redirect: "",
	loading: false,
};

export const isAuthSlice = createSlice({
	name: "auth",
	// estado inicial definido en la parte superior line:3
	initialState,
	// todas las acciones que puden modificar el store
	reducers: {
		setLoading: (state, { payload }) => {
			state.loading = payload;
		},
		verificateToken: (state, { payload }) => {
			state.authentication = payload.authentication;
		},
		loginState: (state, { payload }) => {
			state.authentication = true;
			state.name = payload.name;
			state.email = payload.email;
			state.isAdmin = payload.isAdmin;
			state.isSuperAdmin = payload.isSuperAdmin;
			state.isViewer = payload.isViewer;
			state.isUser = payload.isUser;
		},
		logoutUser: (state, { payload }) => {
			state.authentication = false;
			state.name = "";
			state.email = "";
			state.isAdmin = false;
			state.isSuperAdmin = false;
			state.isViewer = false;
			state.isUser = false;
		},
	},
});

export const { verificateToken, loginState, logoutUser, setLoading } = isAuthSlice.actions;
